<template>
    <div class="order">
        <van-nav-bar title="学校通讯录" left-arrow @click-left="$router.go(-1)" />
        <div style="padding: 10px 20px;">
            <van-button type="primary" block @click="confirmSelection">确定</van-button>
        </div>
        <div v-if="list.length == 0">
            <van-empty description="暂无记录" />
        </div>
        <div v-else>
            <h5 style="padding: 10px 20px;"><van-checkbox v-model="checkAllUser" @click="checkAll">全选</van-checkbox></h5>
            <van-collapse v-model="activeNames">
                <van-collapse-item :title="`学校老师（${list.length}人）`" name="1">
                    <van-checkbox-group v-model="result" ref="checkboxGroup">
                        <van-checkbox v-for="item, index in list" :key="index" :name="item">
                            <van-row
                                style="padding: 10px 10px;margin: 10px 10px;background-color: white;border-radius: 20px;">
                                <van-col span="6">
                                    <van-image round width="60px" height="60px" src="/img/teacher.png" />
                                </van-col>
                                <van-col span="18">
                                    <!-- 学生姓名、刷卡时间 -->
                                    <p style="font-size: 16px;color: black;font-weight: bold;">{{ item.realname }}(教师)
                                    </p>
                                    <p style="font-size: 14px;color: grey;" v-if="item.classes.length">
                                        <span v-for="value in item.classes" :key="value.id">{{ value + ' ' }}</span>
                                    </p>
                                    <p style="font-size: 14px;color: grey;">手机号码: {{ item.phone }}</p>
                                </van-col>
                            </van-row>
                        </van-checkbox>
                    </van-checkbox-group>
                </van-collapse-item>
            </van-collapse>
        </div>
    </div>
</template>

<script>

import { stuGetTeacherBook } from '@/api/teacher'
export default {
    name: 'stuGetTeacherBook',
    components: {

    },
    data() {
        return {
            activeNames: ['1'],
            checkAllUser: false,
            list: [],
            result: []
        }
    },
    mounted() {
        this.getBook()
    },
    methods: {
        async getBook() {
            const response = await stuGetTeacherBook()
            console.log('response', response);
            if (response.code == 10000) {
                this.list = response.data
            }
        },
        confirmSelection() {
            console.log('Selected teachers:', this.result)
            if(this.result.length==0){
                this.$toast.fail('请至少选择一位老师');
                return
            }
            //处理选中结果，只保留id和realname
            this.result = this.result.map(item => ({
                id: item.id,
                realname: item.realname
            }))
            //将结果存入缓存，返回上一页
            localStorage.setItem('selectedTeachers', JSON.stringify(this.result));
            this.$router.go(-1);
        },
        checkAll() {
            console.log(this.$refs.checkboxGroup);
            this.$refs.checkboxGroup.toggleAll();
        },
    },
    watch: {
        result(newVal) {
            this.checkAllUser = newVal.length === this.list.length;
        }
    }
}
</script>

<style lang="less" scoped>
.order {
    background-color: #fafafa;
}
</style>
